import { Box, Button, FormControl, FormLabel, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useSearchMaster, useSearchOptions } from "models/SearchMasterModel";
import { TSharedPage, useSharedPages } from "models/SharedPageModel";
import { useCallback, useState } from "react";
import { atom, useRecoilState } from "recoil";

export const selectedSharedPageAtom = atom<TSharedPage>({
  key: "SharedPageList/SelectedPage/Atom",
  default: undefined,
});

export const SharedPageList = () => {
  const { sharedPages } = useSharedPages();
  const [selectedPage, selectPage] = useRecoilState(selectedSharedPageAtom);

  const { getSearchMasterByProvideKey } = useSearchMaster();
  const ShitenSearchMaster = getSearchMasterByProvideKey("SHITEN_CD");
  const { data: ShitenData } = useSearchOptions(ShitenSearchMaster);
  const ShitenOptions = [{ SHITEN_CD: "_none", NAME: "- 未設定 -" }, ...ShitenData];
  const [shitenCD, setShitenCD] = useState("_none");
  const handleOnChangeShiten = useCallback((event: SelectChangeEvent) => setShitenCD(event.target.value), []);

  return (
    <FormControl component="fieldset" fullWidth sx={{ marginTop: 2, marginBottom: 2, display: "block" }}>
      <FormLabel component="legend">共有ページ</FormLabel>
      <Box sx={{ display: "flex", width: "100%", mt: 2 }} className="hoge">
        <Box sx={{ width: "150px", pt: 1 }}>
          <FormControl fullWidth size="small">
            <InputLabel id="shiten-label">支店</InputLabel>
            <Select
              name="SHITEN_CD"
              label="支店"
              labelId="shiten-label"
              value={shitenCD}
              defaultValue={undefined}
              onChange={handleOnChangeShiten}
              size="small"
              sx={{ fontSize: "small" }}
            >
              {(ShitenOptions as { SHITEN_CD: any; NAME: string }[]).map((op, index) => {
                return (
                  <MenuItem key={index} value={op.SHITEN_CD} dense={true}>
                    {op.NAME}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ display: "flex", flexWrap: "wrap" }}>
          {sharedPages
            .filter((sharedPage: TSharedPage) => sharedPage.status && sharedPage.baseRoute && sharedPage.contents)
            .filter((sharedPage: TSharedPage) => {
              if (!shitenCD || shitenCD === "_none") return true;
              return sharedPage.shitenCD === String(shitenCD);
            })
            .map((sharedPage: TSharedPage) => (
              <Button
                key={sharedPage.id}
                variant={selectedPage && selectedPage.id === sharedPage.id ? "contained" : "outlined"}
                onClick={() => selectPage(sharedPage)}
                sx={{ m: 1, textTransform: "none" }}
              >
                {sharedPage.title}
              </Button>
            ))}
        </Box>
      </Box>
    </FormControl>
  );
};
